import { useMapStore } from "stores/map";

export function useUpdateLayerCircleRadius() {
  const setDisplaySettings = useMapStore((s) => s.setDisplaySettings);

  const updateLayerCircleRadius = (newRadius: number) => {
    // Functional updater (EVA-63) — avoids spreading a stale render-time
    // `displaySettings` snapshot over a concurrently-applied View restore.
    setDisplaySettings((current) => ({ ...current, wellDotThickness: newRadius }));
  };
  return { updateLayerCircleRadius };
}
